<template>
  <div>
    <!--    导航菜单-->
    <el-row>
      <el-col :span="5">
        <el-menu id="funmenu"
                 default-active=1
                 class="el-menu-vertical-demo"
                 background-color="#545c64"
                 text-color="#fff"
                 active-text-color="#ffd04b">
          <el-menu-item index="1" @click="index1">
            <i class="el-icon-document"></i>
            <span slot="title">Gene Expression</span>
          </el-menu-item>
          <el-menu-item index="2" @click="index2">
            <i class="el-icon-document"></i>
            <span slot="title">Tumor Purity and Ploidy</span>
          </el-menu-item>
          <el-menu-item index="3" @click="index3">
            <i class="el-icon-document"></i>
            <span slot="title">Mutations</span>
          </el-menu-item>
          <el-menu-item index="4" @click="index4">
            <i class="el-icon-document"></i>
            <span slot="title">Copy Number Variation</span>
          </el-menu-item>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>Protein Expression</span>
            </template>
            <el-menu-item index="6" @click="index6">Box Plot</el-menu-item>
            <el-menu-item index="7" @click="index7">Volcano Plot</el-menu-item>
          </el-submenu>
          <el-menu-item index="8" @click="index8">
            <i class="el-icon-document"></i>
            <span slot="title">Immune Cell Infiltration</span>
          </el-menu-item>
          <el-menu-item index="9" @click="index9">
            <i class="el-icon-document"></i>
            <span slot="title">Stem Indices</span>
          </el-menu-item>
          <el-menu-item index="10" @click="index10">
            <i class="el-icon-document"></i>
            <span slot="title">Telomere Length</span>
          </el-menu-item>
          <el-menu-item index="11" @click="index11">
            <i class="el-icon-document"></i>
            <span slot="title">Microsatellite Instability</span>
          </el-menu-item>
          <el-menu-item index="12" @click="index12">
            <i class="el-icon-document"></i>
            <span slot="title">Patient Survival</span>
          </el-menu-item>
          <el-menu-item index="13" @click="index13">
            <i class="el-icon-document"></i>
            <span slot="title">Novel Peptide</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="16">
        <!--        fusionset表单-->
        <div class="fslay">
          <br>
          <div class="fslay2">
            <el-row>
              <el-col :span="16" :offset="4">
                <label style="display: inline;margin: auto; margin-right:20px; margin-right:15px;margin-bottom:1px ">Fusion
                  set:</label>
                <el-input v-model="input" @blur="sendMsg" v-focus
                          style="margin: auto; margin-top:10px;margin-bottom:20px;width: 100%"></el-input>
              </el-col>
              <br>
              <el-col :span="12" :offset="6">
                <el-button type="primary" style=" margin-left:110px; font-size:12px; -webkit-appearance: button;
    cursor: pointer;">Example 1
                </el-button>
                <el-button type="primary" style=" margin-left:20px; font-size:12px; -webkit-appearance: button;
    cursor: pointer;">Example 2
                </el-button>
                <el-button type="primary" style=" margin-left:20px; font-size:12px; -webkit-appearance: button;
    cursor: pointer;">Example 3
                </el-button>
              </el-col>
            </el-row>

            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">Customized selection</p>
            </a>
          </div>
        </div>
        <!--Gene Expression-->
        <div v-if="index===1&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Gene Expression Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <el-form :inline="true" class="demo-form-inline">
                  <br>
                  <label style="margin-right: 10px">Gene Name</label>
                  <el-form-item>
                    <el-input v-model="gene" style="width: 200px" placeholder="A1BG,A1CF,"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="getGeneTable">Choose</el-button>
                  </el-form-item>
                </el-form>
                <el-dialog
                  style="margin-top:0px;margin-left: 950px"
                  :modal="false"
                  :close-on-click-modal="false"
                  :visible.sync="geneDialogVisible"
                  width="52%">
                  <div style="height: 428px;overflow: auto;text-align: center">
                    <el-table
                      :data="allgene_list.slice((currentPage-1)*5,currentPage*5)"
                      stripe
                      style="width: 100%;padding-left: 24px"
                      empty-text="No data available in table">
                      <el-table-column
                        type="index"
                        align="center"
                        prop="id"
                        label="id"
                        width="120"></el-table-column>
                      <el-table-column
                        align="center"
                        prop="gene"
                        label="gene"
                        width="120">
                        <template slot-scope="scope"> {{ scope.row.gene }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="Operation"
                        label="Operation"
                        width="120">
                        <template slot-scope="scope">
                          <el-button type="primary" @click='select(scope.row.gene)'>select</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                      <el-pagination
                        small
                        class="el-pager"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="prev, pager, next,jumper"
                        :total="allgene_list.length">
                      </el-pagination>
                    </div>
                  </div>
                </el-dialog>

                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px">Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getRnaseqBar"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Tumor Purity and Ploidy-->
        <div v-if="index===2&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Tumor Purity And Ploidy Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px;"> Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getTumor"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>
            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Mutations-->
        <div v-if="index===3&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Mutations Analysis</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px;"> Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <div>
                  <p
                    style="font-size:15px; margin-left: 350px; font-weight:bold; margin-bottom: 6px; text-align: left;">
                    Select mutation location:</p>
                </div>
                <div>
                  <el-radio-group v-model="muloca">
                    <el-radio :label=0>All locations</el-radio>
                    <el-radio :label=1>In input genes</el-radio>
                  </el-radio-group>
                </div>
                <div>
                  <p
                    style="font-size:15px; margin-left: 350px; margin-top: 13px; font-weight:bold; margin-bottom: 6px; text-align: left;">
                    Select mutaion type:</p>
                </div>
                <div>
                  <el-radio-group v-model="mutype">
                    <el-radio :label=0>Exclusive mutations</el-radio>
                    <el-radio :label=1>Enriched mutations</el-radio>
                  </el-radio-group>
                </div>
                <br>
                <el-button type="primary" @click="mutation"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px;margin-top: 10px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <el-row>
              <el-col :span="22" :offset="1">
                <div class="col-md-10" v-if="mutype===0">
                  <div>
                    <div id="mutation-fusion-summary" class="summary" style="padding-bottom: 15px;"><h3
                      style="margin-top: 0px;margin-bottom:10px">Mutations specifically appear in individuals with
                      selected fusions:</h3></div>
                    <el-table
                      v-loading="loading"
                      :data="fusionmutation_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                      stripe
                      style="width: 100%">
                      <el-table-column
                        sortable
                        align="center"
                        prop="patient_id"
                        label="Patient ID"
                        width="120">
                        <template slot-scope="scope"> {{ scope.row.fields.patient_id }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        sortable
                        prop="cancer"
                        label="Cancer"
                        width="95">
                        <template slot-scope="scope"> {{ scope.row.fields.cancer }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="hugo_symbol"
                        width="140">
                        <template slot="header" slot-scope="scope">
                          Hugo<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Symbol
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.hugo_symbol }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="chromosome"
                        label="Chromosome"
                        width="140">
                        <template slot-scope="scope"> {{ scope.row.fields.chromosome }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        sortable
                        prop="start_positione"
                        label="Start Position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          Start<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.start_position }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="end_position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          End<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.end_position }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_type"
                        width="110">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.variant_type }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_classification"
                        label="Variant Classification"
                        width="160">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;Classification
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.variant_classification }}</template>
                      </el-table-column>
                    </el-table>
                    <!--    分页操作-->
                    <div style="margin-top: 30px">
                      <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="fusionmutation_list.length">
                      </el-pagination>
                    </div>
                  </div>
                  <br>
                  <el-divider></el-divider>
                  <br>
                  <div>
                    <div id="mutation-fusion-summary" class="summary" style="padding-bottom: 15px;"><h3
                      style="margin-top: 0px;margin-bottom:10px">Mutations specifically appear in individuals without
                      selected fusions:</h3></div>
                    <el-table
                      v-loading="loading2"
                      :data="nofusionmutation_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                      stripe
                      style="width: 100%"
                      empty-text="No data available in table">
                      <el-table-column
                        sortable
                        align="center"
                        prop="patient_id"
                        label="Patient ID"
                        width="120">
                        <template slot-scope="scope"> {{ scope.row.fields.patient_id }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        sortable
                        prop="cancer"
                        label="Cancer"
                        width="95">
                        <template slot-scope="scope"> {{ scope.row.fields.cancer }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="hugo_symbol"
                        width="140">
                        <template slot="header" slot-scope="scope">
                          Hugo<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Symbol
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.hugo_symbol }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="chromosome"
                        label="Chromosome"
                        width="140">
                        <template slot-scope="scope"> {{ scope.row.fields.chromosome }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        sortable
                        prop="start_positione"
                        label="Start Position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          Start<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.start_position }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="end_position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          End<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.end_position }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_type"
                        width="110">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.variant_type }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_classification"
                        label="Variant Classification"
                        width="160">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;Classification
                        </template>
                        <template slot-scope="scope"> {{ scope.row.fields.variant_classification }}</template>
                      </el-table-column>
                    </el-table>
                    <!--    分页操作-->
                    <div style="margin-top: 30px">
                      <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="nofusionmutation_list.length">
                      </el-pagination>
                    </div>
                  </div>
                </div>
                <div class="col-md-10" v-if="mutype===1">
                  <div>
                    <div id="mutation-fusion-summary" class="summary" style="padding-bottom: 15px;"><h3
                      style="margin-top: 0px;margin-bottom:10px">Enrich level of mutations in individuals with selected
                      fusions:</h3></div>
                    <el-table
                      v-loading="loading"
                      :data="Enrichmutation_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                      stripe
                      style="width: 100%"
                      empty-text="No data available in table">
                      <el-table-column
                        sortable
                        align="center"
                        prop="patient_id"
                        width="85">
                        <template slot="header" slot-scope="scope">
                          Patient<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbspID
                        </template>
                        <template slot-scope="scope"> {{ scope.row[0] }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        sortable
                        prop="cancer"
                        label="Cancer"
                        width="70">
                        <template slot-scope="scope"> {{ scope.row[1] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="hugo_symbol"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          Hugo<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Symbol
                        </template>
                        <template slot-scope="scope"> {{ scope.row[2] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="chromosome"
                        label="Chromosome"
                        width="120">
                        <template slot-scope="scope"> {{ scope.row[3] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        sortable
                        prop="start_positione"
                        label="Start Position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          Start<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row[4] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="end_position"
                        width="130">
                        <template slot="header" slot-scope="scope">
                          End<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position
                        </template>
                        <template slot-scope="scope"> {{ scope.row[5] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_type"
                        width="110">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type
                        </template>
                        <template slot-scope="scope"> {{ scope.row[6] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="variant_classification"
                        width="150">
                        <template slot="header" slot-scope="scope">
                          Variant<br>&nbsp;&nbsp;&nbsp;Classification
                        </template>
                        <template slot-scope="scope"> {{ scope.row[7] }}</template>
                      </el-table-column>
                      <el-table-column
                        sortable
                        align="center"
                        prop="Enrichment P Value"
                        width="120">
                        <template slot="header" slot-scope="scope">
                          Enrichment<br>&nbsp;&nbsp;&nbsp;P Value
                        </template>
                        <template slot-scope="scope"> {{ scope.row[8] }}</template>
                      </el-table-column>
                    </el-table>
                    <!--    分页操作-->
                    <div style="margin-top: 30px">
                      <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="Enrichmutation_list.length">
                      </el-pagination>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div id="mutation-enrichment-summary-warning" class="summary" style="color: crimson;"><h4
                    style="margin-top: 4px;margin-bottom:10px">Note: Due to the limitation on the computing performance
                    of our web server, users may have to wait for dozens of minutes (depending on mutation number
                    included) until the calculation was finished. <span style="font-weight:bold;">AVOID FREQUENT ATTEMPTS BEFORE IT FINISHED.</span>
                  </h4></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--Copy Number Variation-->
        <div v-if="index===4&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Copy Number Variation Analysis on Violin Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <el-form :inline="true" class="demo-form-inline">
                  <br>
                  <label style="margin-right: 10px">Gene Name</label>
                  <el-form-item>
                    <el-input v-model="gene" style="width: 200px"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="getCNVGeneTable">Choose</el-button>
                  </el-form-item>
                </el-form>
                <el-dialog
                  style="margin-top:0px;margin-left: 950px"
                  :modal="false"
                  :close-on-click-modal="false"
                  :visible.sync="geneDialogVisible"
                  width="50%">
                  <div style="height: 428px;overflow: auto;text-align: center">
                    <el-table
                      :data="allcnvgene_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                      stripe
                      style="width: 100%;padding-left: 24px"
                      empty-text="No data available in table">
                      <el-table-column
                        type="index"
                        align="center"
                        prop="id"
                        label="id"
                        width="120"></el-table-column>
                      <el-table-column
                        align="center"
                        prop="gene"
                        label="gene"
                        width="120">
                        <template slot-scope="scope"> {{ scope.row.gene }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="Operation"
                        label="Operation"
                        width="120">
                        <template slot-scope="scope">
                          <el-button type="primary" @click='select(scope.row.gene)'>select</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                      <el-pagination
                        small
                        class="el-pager"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="prev, pager, next,jumper"
                        :total="allgene_list.length">
                      </el-pagination>
                    </div>
                  </div>
                </el-dialog>
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px">Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <br>
                    <el-checkbox v-model="cnvType"
                                 style="margin-left: 80px; padding-left:7px; font-weight:bold; font-size:15px; ">Correct
                      CNV by ploidy
                    </el-checkbox>
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <br>
                    <br>
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getCNV"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Protein Expression Analysis on Box Plots-->
        <div v-if="index===6&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Protein Expression Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <el-form :inline="true" class="demo-form-inline">
                  <br>
                  <label style="margin-right: 10px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Protein</label>
                  <el-form-item>
                    <el-input v-model="protein" style="width: 200px"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="getProteinTable">Choose</el-button>
                  </el-form-item>
                </el-form>
                <el-dialog
                  style="margin-top:0px;margin-left: 950px"
                  :modal="false"
                  :close-on-click-modal="false"
                  :visible.sync="proteinDialogVisible"
                  width="52%">
                  <div style="height: 428px;overflow: auto;text-align: center">
                    <el-table
                      :data="allprotein_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                      stripe
                      style="width: 100%;padding-left: 24px"
                      empty-text="No data available in table">
                      <el-table-column
                        type="index"
                        align="center"
                        prop="id"
                        label="id"
                        width="100"></el-table-column>
                      <el-table-column
                        align="center"
                        prop="protein"
                        label="protein"
                        width="180">
                        <template slot-scope="scope"> {{ scope.row }}</template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="Operation"
                        label="Operation"
                        width="120">
                        <template slot-scope="scope">
                          <el-button type="primary" @click='selectp(scope.row)'>select</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                      <el-pagination
                        small
                        class="el-pager"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="prev, pager, next,jumper"
                        :total="allprotein_list.length">
                      </el-pagination>
                    </div>
                  </div>
                </el-dialog>
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px">Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getBarProtein"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Protein Expression Analysis on Volcano Plots-->
        <div v-if="index===7&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Protein Expression Analysis on Volcano Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px;"> Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">|Log2FC|
                        Cutoff</label>
                      <br>
                      <el-input v-model="fcValue" style="width: 200px;margin-left: 15px" placeholder="1"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">q-value
                        Cutoff</label>
                      <br>
                      <el-input v-model="qValue" style="width: 200px;margin-left: 10px" placeholder="0.01"></el-input>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getVolcanoPlot"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Immune Cell Infiltration Analysis on Box Plots-->
        <div v-if="index===8&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Immune Cell Infiltration Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">

                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 580px">tumor abbreviations</u>
                </a>
                <br>
                <!--Cancertransfer-->
                <div id="cancertransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
                  <el-checkbox v-model="checked1" @change="cancerboxuse" style="margin-right: 30px;">Cancer
                  </el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block;"
                    v-model="value2"
                    :data="data2"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange">
                  </el-transfer>
                </div>
                <!--Typetransfer-->
                <div id="typetransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;">
                  <el-checkbox v-model="checked2" @change="typeboxuse" style="margin-right: 30px;">&nbsp;&nbsp;Type&nbsp;&nbsp;</el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="value3"
                    :data="data3"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange"
                    @mouseover.native="addTitle">
                  </el-transfer>
                </div>
                <br>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <br>
                    <el-checkbox v-model="pvalue"
                                 style="margin-left: 200px; padding-left:7px; font-weight:bold; font-size:15px; ">
                      p-Value：Show result with significant difference (p < 0.05)
                    </el-checkbox>
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <br>
                    <br>
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getImmune"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Stem Indices Analysis on Box Plots-->
        <div v-if="index===9&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Stem Indices Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">

                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 580px">tumor abbreviations</u>
                </a>
                <br>
                <!--Cancertransfer-->
                <div id="cancertransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
                  <el-checkbox v-model="checked1" @change="cancerboxuse" style="margin-right: 30px;">Cancer
                  </el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block;"
                    v-model="value2"
                    :data="data2"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange">
                  </el-transfer>
                </div>
                <!--Typetransfer-->
                <div id="stemtypetransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;">
                  <el-checkbox v-model="stemtypeuse" @change="stemtypeboxuse" style="margin-right: 30px;">&nbsp;&nbsp;Type&nbsp;&nbsp;</el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="stemtypevalue"
                    :data="data4"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange">
                  </el-transfer>
                </div>
                <br>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <br>
                    <el-checkbox v-model="logScale"
                                 style="margin-left: 200px; padding-left:7px; font-weight:bold; font-size:15px; ">
                      Log Scale：Log2 transformation for each value
                    </el-checkbox>
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <br>
                    <br>
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getStemIndices"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Telomere Length Analysis on Box Plots-->
        <div v-if="index===10&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Telomere Length Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">

                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 580px">tumor abbreviations</u>
                </a>
                <br>
                <!--Cancertransfer-->
                <div id="cancertransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
                  <el-checkbox v-model="checked1" @change="cancerboxuse" style="margin-right: 30px;">Cancer
                  </el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block;"
                    v-model="value2"
                    :data="data2"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange">
                  </el-transfer>
                </div>
                <br>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <br>
                    <el-checkbox v-model="checked3"
                                 style="margin-left: 200px; padding-left:7px; font-weight:bold; font-size:15px; ">
                      Log Scale：Log2 transformation for each value
                    </el-checkbox>
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <br>
                    <br>
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getTelomere"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Microsatellite Instability Analysis on Box Plots-->
        <div v-if="index===11&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Microsatellite Instability Analysis on Box Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">

                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 580px">tumor abbreviations</u>
                </a>
                <br>
                <!--Cancertransfer-->
                <div id="cancertransfer"
                     style="border: 1px solid #ccc;width: 900px;margin-left: 85px;padding-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
                  <el-checkbox v-model="checked1" @change="cancerboxuse" style="margin-right: 30px;">Cancer
                  </el-checkbox>
                  <el-transfer
                    style="text-align: left; display: inline-block;"
                    v-model="value2"
                    :data="data2"
                    filterable
                    :titles="['Source', 'Target']"
                    :button-texts="['', '']"
                    :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                    @change="handleChange">
                  </el-transfer>
                </div>
                <br>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <br>
                    <el-checkbox v-model="checked3"
                                 style="margin-left: 200px; padding-left:7px; font-weight:bold; font-size:15px; ">
                      Log Scale：Log2 transformation for each value
                    </el-checkbox>
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <br>
                    <br>
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getMsi"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Patient Survival Analysis on Survival Plots-->
        <div v-if="index===12&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Patient Survival Analysis on Survival Plots</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <p style="font-size: 20px;
            margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;"><strong style="font-weight: 700;">Condition:</strong></p>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <label class="control-label" for="multiselect" style="width: 100%;font-size: 16px;"> Cancer
                  Selection</label>
                <br>
                <a target="_blank"
                   style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;">
                  <u style="text-decoration: underline;font-size: 14px;margin-left: 470px">tumor abbreviations</u>
                </a>
                <el-transfer
                  style="text-align: left; display: inline-block"
                  v-model="value"
                  :data="data"
                  filterable
                  :titles="['Source', 'Target']"
                  :button-texts="['', '']"
                  :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
               }"
                  @change="handleChange">
                </el-transfer>
                <!--condition下拉框-->
                <div style="border: 1px solid #ccc;padding: 8px 20px;border-radius: 0px 4px 4px 0px;margin:30px 350px">
                  <label class="control-label" for="if-conf" style="width: 100%;text-align: left">95% Confidence
                    Interval</label>
                  <el-select v-model="ifconf" placeholder="请选择"
                             style="width: 100%;margin-bottom: 10px;font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;">
                    <el-option label="Yes" value="true"></el-option>
                    <el-option label="No" value="false"></el-option>
                  </el-select>
                  <label class="control-label" for="if-conf" style="width: 100%;text-align: left">Axis Units</label>
                  <el-select v-model="axlab" placeholder="请选择"
                             style="width: 100%;margin-bottom: 10px;font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;">
                    <el-option label="Days" value="Days"></el-option>
                    <el-option label="Months" value="Months"></el-option>
                  </el-select>
                  <label class="control-label" for="if-conf" style="width: 100%;text-align: left">Method</label>
                  <el-select v-model="survivalMethod" placeholder="请选择"
                             style="width: 100%;margin-bottom: 10px;font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;">
                    <el-option label="OS(Overall Survival)" value="OS"></el-option>
                    <el-option label="PFS(Progression-free Survival)" value="PFS"></el-option>
                  </el-select>

                </div>
                <el-row>
                  <el-col :span="10" :offset="1">
                    <div class="block1" style="margin-left: 130px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 200px">Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color1" style="margin-left: 10px"></el-color-picker>
                    </div>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <div class="block1" style="margin-left: 100px">
                      <label class="control-label" for="fusion-color" style="padding-left:17px;width: 300px">Non-Fusion
                        Color</label>
                      <br>
                      <el-color-picker v-model="color2"></el-color-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="getSurvival"
                           style="width: 100px;height: 50px;font-size: 20px;margin-bottom: 50px">Plot
                </el-button>
              </div>

            </div>
          </div>
          <div id="myPlotDiv" class="col-md-12" v-if="isPDFshow"
               style="margin-top: 20px; padding-bottom: 30px; border: 1px solid rgb(204, 204, 204); display: block;">
            <br>
            <p style="font-size: 20px"><strong>Result:</strong></p>
            <div class="container-fluid">
              <iframe id="myPlotIframe" width="100%" height="585px"
                      :src="pdfURL"></iframe>
            </div>
          </div>
        </div>
        <!--Novel Peptide-->
        <div v-if="index===13&&isShow">
          <div class="futitle">
            <br>
            <p style="font-size: 23px;margin: 0 0 10px;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;">
              <strong style="font-weight: 700;">Novel Peptide</strong></p>
          </div>
          <div class="fudetail">
            <br>
            <a
              style="color: #337ab7;text-decoration: none;background-color: transparent;cursor: pointer;box-sizing: border-box;">
              <p class="help-label text-center" style="text-align: center;margin: 0 0 10px;display: block;
                  margin-block-start: 1em;
                  margin-block-end: 1em;
                  margin-inline-start: 0px;
                  margin-inline-end: 0px;">-- Help -- </p>
            </a>
            <div class="fuform">
              <div style="text-align: center">
                <el-table
                  :data="peptide_list.slice((currentPage-1)*PageSize,currentPage*PageSize)"
                  stripe
                  style="width: 100%;margin-bottom: 30px"
                  empty-text="No data available in table">
                  <el-table-column
                    type="index"
                    align="center"
                    prop="id"
                    label="No"
                    width="100"></el-table-column>
                  <el-table-column
                    align="center"
                    sortable
                    prop="fusion"
                    label="Fusion"
                    width="220">
                    <template slot-scope="scope"> {{ scope.row.fusion }}</template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    align="center"
                    prop="peptide_sequence"
                    label="Peptide Sequence"
                    width="220">
                    <template slot-scope="scope"> {{ scope.row.peptide_sequence }}</template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="unmatch"
                    label="Unmatch"
                    width="200">
                    <template slot-scope="scope"> {{ scope.row.unmatch }}</template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    sortable
                    prop="proteome/phosphoproteome"
                    label="Proteome/Phosphoproteome"
                    width="400">
                    <template slot-scope="scope">
                      <el-link :href="scope.row.website" target="_blank">{{
                          scope.row.proteome_phosphoproteome
                        }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "functionalities",
  data() {
    return {
      muloca: 0,
      mutype: 0,
      cnvType: false,
      checked1: false,
      checked2: false,
      stemtypeuse: false,
      pvalue: false,
      logScale: false,
      fcValue: '1',
      qValue: '0.01',
      index: 1,
      isShow: true,
      isPDFshow: false,
      isExcorEnr: true,
      input: '',
      send: '',
      cancers: ['ACC', 'BLCA', 'BRCA', 'CESC', 'CHOL', 'COAD', 'DLBC', 'ESCA', 'GBM', 'HNSC', 'KICH', 'KIRC', 'KIRP',
        'LAML', 'LGG', 'LIHC', 'LUAD', 'LUSC', 'MESO', 'OV', 'PAAD', 'PCPG', 'PRAD', 'READ', 'SARC', 'SKCM', 'STAD', 'TGCT',
        'THCA', 'THYM', 'UCEC', 'UVM'],
      cancers2: [],
      alltype: ['B cell memory', 'B cell naive', 'B cell plasma', 'Eosinophil', 'Macrophage M0', 'Macrophage M1', 'Macrophage M2', 'Mast cell activated',
        'Mast cell resting', 'Monocyte', 'Myeloid dendritic cell activated', 'Myeloid dendritic cell resting', 'NK cell activated', 'NK cell resting',
        'Neutrophil', 'T cell CD4+ memory activated', 'T cell CD4+ memory resting', 'T cell CD4+ naive', 'T cell CD8+', 'T cell follicular helper', 'T cell gamma delta',
        'T cell regulatory'],
      allstemtype: ['DMPsi', 'ENHsi', 'EREG_mDNAsi', 'EREG_mRNAsi', 'mDNAsi', 'mRNAsi'],
      type: [],
      stemtype: [],
      field: ['b_cell_memory;B cell memory', 'b_cell_naive;B cell naive', 'b_cell_plasma;B cell plasma', 'eosinophil;Eosinophil', 'macrophage_m0;Macrophage M0', 'macrophage_m1;Macrophage M1', 'macrophage_m2;Macrophage M2', 'mast_cell_activated;Mast cell activated', 'mast_cell_resting;Mast cell resting', 'monocyte;Monocyte', 'myeloid_dendritic_cell_activated;Myeloid dendritic cell activated', 'myeloid_dendritic_cell_resting;Myeloid dendritic cell resting', 'nk_cell_activated;NK cell activated', 'nk_cell_resting;NK cell resting', 'neutrophil;Neutrophil', 't_cell_cd4+_memory_activated;T cell CD4+ memory activated', 't_cell_cd4+_memory_resting;T cell CD4+ memory resting', 't_cell_cd4+_naive;T cell CD4+ naive', 't_cell_cd8+;T cell CD8+', 't_cell_follicular_helper;T cell follicular helper', 't_cell_gamma_delta;T cell gamma delta', 't_cell_regulatory_tregs;T cell regulatory (Tregs)'],
      stemfield: ['1;DMPsi', '1;ENHsi', '1;EREG_mDNAsi', '2;EREG_mRNAsi', '1;mDNAsi', '2;mRNAsi'],
      gene: '',
      protein: '',
      value: [],
      value2: [],
      value3: [],
      stemtypevalue: [],
      ifconf: '',
      axlab: '',
      survivalMethod: '',
      color1: '#efc8c5',
      color2: '#a4dddf',
      geneDialogVisible: false,
      proteinDialogVisible: false,
      loading: true,
      loading2: true,
      allgene_list: [],
      allcnvgene_list: [],
      allprotein_list: [],
      peptide_list: [],
      fusionmutation_list: [],
      nofusionmutation_list: [],
      Enrichmutation_list: [],
      pdfURL: '',
      // 分页
      // 默认显示第几页
      currentPage: 1,
      // 个数选择器（可修改）
      pageSizes: [20, 50, 100, 200, 300, 400],
      // 默认每页显示的条数（可修改）
      PageSize: 20,
    }
  },
  computed: {
    data: function () {
      const data = [];
      this.cancers.forEach((cancer, index) => {
        data.push({
          label: cancer,
          key: cancer,
        });
      });
      return data;
    },
    data2: function () {
      const data = [];
      this.cancers2.forEach((cancer, index) => {
        data.push({
          label: cancer,
          key: cancer,
        });
      });
      return data;
    },
    data3: function () {
      const data = [];
      this.type.forEach((type, index) => {
        data.push({
          label: type,
          key: this.field[index],
        });
      });
      return data;
    },
    data4: function () {
      const data = [];
      this.stemtype.forEach((type, index) => {
        data.push({
          label: type,
          key: this.stemfield[index],
        });
      });
      return data;
    }
  },
  created() {
    var query = this.$route.query
    this.input = query.fusion
    this.showGenetable()
    this.showCNVGenetable()
    this.showProteintable()
  },
  methods: {
    sendMsg() {
      //同步cancer穿梭框的值
      this.$http.get('http://bioinfo-sysu.com:9000/api/set_cancers?fusions=' +
        this.input)
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            var reg1 = new RegExp("\\[", "g");
            var reg2 = new RegExp("]", "g");
            var reg3 = new RegExp("\"", "g");
            var reg4 = new RegExp("TCGA-", "g");
            var reg5 = new RegExp(" ", "g");
            let arr = res['list'].replace(reg1, '').replace(reg2, '').replace(reg3, '').replace(reg4, '').replace(reg5, '').split(',')
            let newsArr = [];
            for (let i = 0; i < arr.length; i++) {
              if (newsArr.indexOf(arr[i]) === -1) {
                newsArr.push(arr[i]);
              }
            }
            this.cancers = newsArr
            console.log(this.cancers)
          }
        })
    },
    handleChange() {
      console.log(this.value)
    },
    getRnaseqBar() {
      if (this.input == '') {
        this.$message.error({message: 'Please input vaild fusion.', customClass: 'alert'});
      } else if (this.value == '') {
        this.$message.error({message: 'Pleace choose at least one cancer', customClass: 'alert'});
      } else {
        if (this.gene == '') {
          this.gene = 'A1BG,A1CF,'
        }
        //this.fusions  et = store.state.fusion.input
        this.$http.get('http://bioinfo-sysu.com:9000/api/getRnaseqBar',
          {
            params: {
              cancer: this.value.toString(),
              fusion: this.input,
              gene: this.gene,
              fusionColor: this.color1,
              nonfusionColor: this.color2
            },
            responseType: 'blob'
          }
        )
          .then((response) => {
            if (response.body.respCode == '999999') {
              this.$notify.error({
                title: 'Error',
                message: 'Sorry,Some samples are missing corresponding data'
              });
            } else {
              let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
              this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
              this.isPDFshow = true
            }
          })
      }
    },
    getTumor() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getTumor',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            fusionColor: this.color1,
            nonfusionColor: this.color2
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    mutation() {
      this.loading = true
      this.loading2 = true
      this.fusionmutation_list = []
      if (this.mutype == 0) {
        this.$http.get('http://bioinfo-sysu.com:9000/api/getFusionMutation',
          {
            params: {
              cancer: this.value.toString(),
              fusion: this.input,
              checked: this.muloca
            }
          }
        )
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.fusionmutation_list = res['list']
              this.loading = false
            }
          })
        this.$http.get('http://bioinfo-sysu.com:9000/api/getNonfusionMutation',
          {
            params: {
              cancer: this.value.toString(),
              fusion: this.input,
              checked: this.muloca
            }
          }
        )
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.nofusionmutation_list = res['list']
              this.loading2 = false
            }
          })
      } else {
        this.$http.get('http://bioinfo-sysu.com:9000/api/getEnrichedFusion',
          {
            params: {
              cancer: this.value.toString(),
              fusion: this.input,
              checked: this.muloca
            }
          }
        )
          .then((response) => {
            var res = JSON.parse(response.bodyText)
            if (res.respCode === '000000') {
              this.Enrichmutation_list = res['list']
              this.loading = false
            }
          })
      }
      this.isPDFshow = true
    },
    getCNV() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getCNV',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            genes: this.gene,
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            cnvType: this.cnvType
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getImmune() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getImmune',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            type: this.value3.toString(),
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            pvalue: this.pvalue,
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getStemIndices() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getStemIndices',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            type: this.stemtypevalue.toString(),
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            pvalue: false,
            logScale: this.logScale
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getTelomere() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getTelomere',
        {
          params: {
            cancer: this.value2.toString(),
            fusion: this.input,
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            pvalue: false,
            logScale: this.logScale
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getMsi() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getMsi',
        {
          params: {
            cancer: this.value2.toString(),
            fusion: this.input,
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            pvalue: false,
            logScale: this.logScale
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getSurvival() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getSurvival',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            fusionColor: this.color1,
            nonfusionColor: this.color2,
            ifconf: this.ifconf,
            axlab: this.axlab,
            survivalMethod: this.survivalMethod
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getBarProtein() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getBarProtein',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            category: this.protein,
            fusionColor: this.color1,
            nonfusionColor: this.color2,
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getVolcanoPlot() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getVolcanoPlot',
        {
          params: {
            cancer: this.value.toString(),
            fusion: this.input,
            fcValue: this.fcValue,
            qValue: this.qValue
          },
          responseType: 'blob'
        },
      )
        .then((response) => {
          if (response.body.respCode == '999999') {
            this.$notify.error({
              title: 'Error',
              message: 'Sorry,Some samples are missing corresponding data'
            });
          } else {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf;charset=utf-8"}));
            this.pdfURL = '../../fusionatlas/static/pdf/web/viewer.html?file=' + url
            this.isPDFshow = true
          }
        })
    },
    getPeptide() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getPeptide',
        {
          params: {
            fusion: this.input,
          }
        })
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.peptide_list = res['list']
          }
        })
    },
    index1() {
      this.index = 1
      this.value = []
      this.gene = ''
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index2() {
      this.index = 2
      this.value = []
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index3() {
      this.index = 3
      this.value = []
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index4() {
      this.index = 4
      this.value = []
      this.gene = ''
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index6() {
      this.index = 6
      this.value = []
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index7() {
      this.index = 7
      this.value = []
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index8() {
      this.index = 8
      this.checked1 = false
      this.value2 = []
      this.cancers2 = []
      var tb = document.getElementById("cancertransfer")
      tb.style.backgroundColor = '#eee'
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index9() {
      this.index = 9
      this.checked1 = false
      this.value2 = []
      this.cancers2 = []
      var tb = document.getElementById("cancertransfer")
      tb.style.backgroundColor = '#eee'
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index10() {
      this.index = 10
      this.checked1 = false
      this.value2 = []
      this.cancers2 = []
      var tb = document.getElementById("cancertransfer")
      tb.style.backgroundColor = '#eee'
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index11() {
      this.index = 11
      this.checked1 = false
      this.value2 = []
      this.cancers2 = []
      var tb = document.getElementById("cancertransfer")
      tb.style.backgroundColor = '#eee'
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index12() {
      this.index = 12
      this.value = []
      this.isPDFshow = false
      this.pdfURL = ''
    },
    index13() {
      this.index = 13
      this.isPDFshow = false
      this.getPeptide()
      this.isPDFshow = false
      this.pdfURL = ''
    },
    cancerboxuse() {
      var cb = document.getElementById("cancertransfer")
      this.value2 = []
      if (this.checked1) {
        this.cancers2 = this.cancers
        cb.style.backgroundColor = '#fff'
      } else {
        this.cancers2 = []
        cb.style.backgroundColor = '#eee'
      }
    },
    typeboxuse() {
      this.value3 = []
      var tb = document.getElementById("typetransfer")
      if (this.checked2) {
        this.type = this.alltype
        tb.style.backgroundColor = '#fff'
      } else {
        this.type = []
        tb.style.backgroundColor = '#eee'
      }
    },
    stemtypeboxuse() {
      this.stemtypevalue = []
      var tb = document.getElementById("stemtypetransfer")
      if (this.stemtypeuse) {
        this.stemtype = this.allstemtype
        tb.style.backgroundColor = '#fff'
      } else {
        this.stemtype = []
        tb.style.backgroundColor = '#eee'
      }
    },
    getGeneTable() {
      this.geneDialogVisible = true
    },
    getCNVGeneTable() {
      this.geneDialogVisible = true
    },
    getProteinTable() {
      this.proteinDialogVisible = true
    },
    showGenetable() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/show_gene_table')
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.allgene_list = res['list']
          }
        })
    },
    showCNVGenetable() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/showCNVGenetable')
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.allcnvgene_list = res['list']
          }
        })
    },
    showProteintable() {
      this.$http.get('http://bioinfo-sysu.com:9000/api/getProteinOption')
        .then((response) => {
          var res = JSON.parse(response.bodyText)
          if (res.respCode === '000000') {
            this.allprotein_list = res['list']
          }
        })
    },
    //分页
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    },
    select(gene) {
      if (this.gene.indexOf(gene) == -1) {
        this.gene = this.gene + gene + ','
      }
    },
    selectp(protein) {
      if (this.protein.indexOf(protein) == -1) {
        this.protein = this.protein + protein + ','
      }
    },
    //解决穿梭框字段过长无法显示
    addTitle(e) {
      //手动给鼠标划过的元素添加一个title
      let target_el = e.target;
      if (target_el.title) return;
      target_el.title = target_el.innerText;
    },
  },
  //进入后输入框自动获取焦点
  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },


}
</script>

<style scoped>
#funmenu {
  float: left;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
}

.fslay {
  margin-top: 20px;
  padding-bottom: 30px;
  border: 1px solid #ccc;
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  display: block;
}

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 16px;
  box-sizing: border-box;
  cursor: default;
}

.futitle {
  position: relative;
  min-height: 1px;
  width: 100%;
  float: left;
  padding-right: 15px;
  padding-left: 15px;
}

.fudetail {
  border: 1px solid #ccc;
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  display: block;
}

.fuform {
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  display: block;
  box-sizing: border-box;
}

.block1 {
  padding-top: 15px;
  width: 50%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  display: block;
}

#cancertransfer {
  background-color: #eee;
}

#typetransfer {
  background-color: #eee;
}

#stemtypetransfer {
  background-color: #eee;
}

.container-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

#myPlotDiv {
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-md-10 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

h3 {
  font-size: 24px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
<style>
.alert {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Functionalities.vue